import capital from './assets/capital.json';
import phone from './assets/phone.json';
import { detect } from 'detect-browser' ;
import { useState } from 'react';
import http from './httpService';
import { rgbaStringToObject } from './transformations';
import { lightOrDark } from './lightOrDarkColor';
import get from 'lodash.get';

/**
 * *******************************************************************************************************************
 * @returns {boolean}
 ***********************************************************************************************************************/
const isSupportedBrowser = () => {
    const browser = detect();
    const versionSplit = +browser.version.split( '.' )[ 0 ];
    const nameCase = browser.name.toLowerCase();
    const osCase = browser.os.toLowerCase();

    if ( nameCase === 'ie' && versionSplit <= 11 ) {
        return false;
    }
    if ( nameCase === 'edge' ) {
        return false;
    }

    if ( osCase === 'android os' && nameCase === 'samsung' ) {
        return true;
    }

    if ( osCase === 'android os' && nameCase !== 'samsung' && versionSplit <= 70) {
        return false;
    }

    return true;
};

/**
 *
 * @param code
 * @returns {null|*}
 */
const getCapital = ( code ) => {
    for ( let key in phone ) {
        if ( phone[ key ] === code ) {
            for ( let kode in capital ) {
                if ( kode === key ) {
                    return capital[ kode ];
                }
            }
            break;
        }
    }
    return null;
};

/***********************************************************************************************************************
 *
 * @param len
 * @returns {string}
 ***********************************************************************************************************************/
const generateId = ( len ) => {
    const dec2hex = ( dec ) => {
        return ( '0' + dec.toString( 16 ) ).substr( -2 );
    };
    let arr = new Uint8Array( ( len || 40 ) / 2 );
    window.crypto.getRandomValues( arr );
    return Array.from( arr, dec2hex ).join( '' );
};

/***********************************************************************************************************************
 *
 * @param string
 * @returns {*}
 **********************************************************************************************************************/
const escapeRegExp = string => {
    return string.replace( /[.*+?^${}()|[\]\\]/g, '\\$&' ); // $& means the whole matched string
};

/***********************************************************************************************************************
 *
 * @param func
 * @param wait
 * @param immediate
 * @returns {Function}
 ***********************************************************************************************************************/
const debounce = ( func, wait, immediate ) => {
    let timeout;
    return function () {
        let context = this, args = arguments;
        let later = function () {
            timeout = null;
            if ( !immediate ) func.apply( context, args );
        };
        let callNow = immediate && !timeout;
        clearTimeout( timeout );
        timeout = setTimeout( later, wait );
        if ( callNow ) func.apply( context, args );
    };
};
/***********************************************************************************************************************
 *
 * @param languageName
 * @returns {number}
 ***********************************************************************************************************************/
const getLangIdByName = ( languageName ) => {
    switch ( languageName.toLowerCase() ) {
        case 'english':
            return 1;
        case 'svenska':
            return 2;
        case 'norsk':
            return 3;
        case 'dansk':
            return 4;
        case 'suomi':
            return 5;
        case 'russian':
            return 6;
        case 'spanish':
            return 7;
        case 'chinese':
            return 8;
        case 'portuguese':
            return 9;
        case 'polish':
            return 10;
        case 'turkish':
            return 11;
        case 'dutch':
            return 12;
        case 'french':
            return 13;
        case 'german':
            return 14;
        case 'hindi':
            return 15;
        case 'italian':
            return 16;
        case 'japanese':
            return 17;
        case 'korean':
            return 18;
        default:
            return 1;
    }
};
/***********************************************************************************************************************
 *
 * @param languageID
 * @returns {string}
 **********************************************************************************************************************/
const getLangCodeById = ( languageID ) => {
    switch ( languageID ) {
        case 1: {
            return 'en';
        }
        case 2: {
            return 'se';
        }
        case 3: {
            return 'no';
        }
        case 4: {
            return 'da';
        }
        case 5: {
            return 'fi';
        }
        case 6: {
            return 'ru';
        }
        case 7: {
            return 'sp';
        }
        case 8: {
            return 'ch';
        }
        case 9: {
            return 'bz';
        }
        case 10: {
            return 'pl';
        }
        case 11: {
            return 'tk';
        }
        case 12: {
            return 'nd';
        }
        case 13: {
            return 'fr';
        }
        case 14: {
            return 'gm';
        }
        case 15: {
            return 'hd';
        }
        case 16: {
            return 'it';
        }
        case 17: {
            return 'jp';
        }
        case 18: {
            return 'kr';
        }
        default:
            return 'en';
    }
};
/***********************************************************************************************************************
 *
 * @param languageID
 * @returns {string}
 **********************************************************************************************************************/
const getLangNameById = ( languageID ) => {
    switch ( languageID ) {
        case 1:
            return 'English';
        case 2:
            return 'Svenska';
        case 3:
            return 'Norsk';
        case 4:
            return 'Dansk';
        case 5:
            return 'Suomi';
        case 6:
            return 'Russian';
        case 7:
            return 'Spanish';
        case 8:
            return 'Chinese';
        case 9:
            return 'Portuguese';
        case 10:
            return 'Polish';
        case 11:
            return 'Turkish';
        case 12:
            return 'Dutch';
        case 13:
            return 'French';
        case 14:
            return 'German';
        case 15:
            return 'Hindi';
        case 16:
            return 'Italian';
        case 17:
            return 'Japanese';
        case 18:
            return 'Korean';
        default:
            return 'English';
    }
};
/***********************************************************************************************************************
 *
 * @returns {boolean}
 **********************************************************************************************************************/
const isRunningOnServerSide = () => {
    return typeof ( window ) === 'undefined';
};
/***********************************************************************************************************************
 *
 * @returns {boolean}
 **********************************************************************************************************************/
const isRunningOnClientSide = () => {
    return typeof ( window ) !== 'undefined';
};

/***********************************************************************************************************************
 *
 * @returns {boolean}
 **********************************************************************************************************************/
const isFacebookApp = () => {
    let ua = navigator.userAgent || navigator.vendor || window.opera;
    return ( ua.indexOf( 'FBAN' ) > -1 ) || ( ua.indexOf( 'FBAV' ) > -1 );
};

/***********************************************************************************************************************
 *
 * @param buffer
 * @param resolve
 * @returns {string}
 **********************************************************************************************************************/
const createFontBlob = ( buffer, resolve ) => {
    const b64toBlob = ( b64Data, contentType = '', sliceSize = 512 ) => {
        const byteCharacters = atob( b64Data );
        const byteArrays = [];

        for ( let offset = 0 ; offset < byteCharacters.length ; offset += sliceSize ) {
            const slice = byteCharacters.slice( offset, offset + sliceSize );
            const byteNumbers = new Array( slice.length );

            for ( let i = 0 ; i < slice.length ; i++ ) {
                byteNumbers[ i ] = slice.charCodeAt( i );
            }

            const byteArray = new Uint8Array( byteNumbers );
            byteArrays.push( byteArray );
        }

        return new Blob( byteArrays, { type: contentType } );
    };

    const blob = b64toBlob( buffer, 'application/font' );
    if ( typeof resolve === 'function' ) {
        resolve( URL.createObjectURL( blob ) );
    } else {
        return URL.createObjectURL( blob );
    }
};

/**
 *
 * @returns {boolean}
 */
const isIframe = () => {
    let isFramed = false;
    try {
        isFramed = window != window.top || document != top.document || self.location != top.location;
    } catch ( e ) {
        isFramed = true;
    }
    return isFramed;
};


/**
 *
 * @returns {function(): *}
 */
const useForceUpdate = () => {
    const [ value, setValue ] = useState( 0 );
    return () => setValue( value => value + 1 );
};

/**
 *
 * @param ev
 * @param gameId
 * @param isPreview
 * @returns {string}
 */
const onUnload = ( ev, gameId, isPreview ) => {
    ev.preventDefault();
    http.trackWindowClose( gameId, isPreview );
    return ev.returnValue = 'Are you sure you want to close?';
};


/**
 *
 * @param imgUrl
 * @param resolve
 */
const drawBackgroundPix = ( imgUrl, resolve ) => {
    const image = new Image();
    image.crossOrigin = '';
    image.src = imgUrl;
    const canvas = document.createElement( 'canvas' );
    const context = canvas.getContext( '2d' );
    image.onload = () => {
        context.drawImage( image, 0, 0 );
        if ( typeof resolve === 'function' ) {
            const data = context.getImageData( 5, 5, 1, 1 ).data;
            resolve( data );
        }
    };
};

/**
 *
 * @param buffer
 * @param resolve
 * @returns {string}
 */
const createFoneImage = ( buffer, resolve ) => {

    const b64toBlob = ( b64Data, contentType = '', sliceSize = 512 ) => {
        const byteCharacters = atob( b64Data );
        const byteArrays = [];

        for ( let offset = 0 ; offset < byteCharacters.length ; offset += sliceSize ) {
            const slice = byteCharacters.slice( offset, offset + sliceSize );
            const byteNumbers = new Array( slice.length );

            for ( let i = 0 ; i < slice.length ; i++ ) {
                byteNumbers[ i ] = slice.charCodeAt( i );
            }

            const byteArray = new Uint8Array( byteNumbers );
            byteArrays.push( byteArray );
        }

        return new Blob( byteArrays, { type: contentType } );
    };

    const blob = b64toBlob( buffer, 'image/jpeg' );
    if ( typeof resolve === 'function' ) {
        resolve( URL.createObjectURL( blob ) );
    } else {
        return URL.createObjectURL( blob );
    }

};

/**
 *
 * @returns {boolean}
 */
const checkSafariBackdropSupport = () => {
    let userAgent = navigator.userAgent || '';
    let browser = userAgent.slice( userAgent.indexOf( 'Version/' ) + 8 );

    if ( !browser.includes( 'Safari' ) ) {
        return false;
    }

    if ( browser.includes( '12.0.1' ) || browser.includes( '12.0.0' ) ) {
        return false;
    }

    if ( browser.split( '.' )[ 0 ] < 12 ) {
        return false;
    }

    return true;
};

/**
 *
 * @returns {string}
 */
const isSlash = () => {
    const isDeleteSlash = window.location.href.split( '' );
    return ( isDeleteSlash[ isDeleteSlash.length - 1 ] === '/' ) ? '' : '/';
};

/**
 *
 * @param url
 * @param key
 * @returns {URL}
 */
const editUrl = ( url, key ) => {

    const objUrl = new URL( url );

    if ( objUrl.searchParams.has( 'sj_n' ) ) {
        objUrl.searchParams.delete( 'sj_n' );
    }

    if ( objUrl.searchParams.has( 'sj_m' ) ) {
        objUrl.searchParams.delete( 'sj_m' );
    }

    if ( objUrl.searchParams.has( 'sj_e' ) ) {
        objUrl.searchParams.delete( 'sj_e' );
    }

    if ( key && objUrl.searchParams.has( 'key' ) === false ) {
        objUrl.searchParams.append( 'key', key );
    }

    return objUrl;
};


/*******************************************************************************************************************
 *
 * @param appearance
 */
const setFonts = ( appearance ) => {
    if ( appearance && appearance.font_style ) {
        const { fontProps, fontFamilyHeader, fontFamilyHeaderH2 } = appearance.font_style;

        if ( fontProps && fontProps.fontUrl ) {
            let fontStyleEl = document.createElement( 'style' );

            fontStyleEl.appendChild( document.createTextNode( `@font-face { font-family: ${ fontProps.fontName }; src: url('${ fontProps.fontUrl }') format('${ fontProps.format }'); }` ) );
            document.head.appendChild( fontStyleEl );
        }
        if ( fontFamilyHeader && fontFamilyHeader.fontUrl ) {
            let fontStyleEl = document.createElement( 'style' );

            fontStyleEl.appendChild( document.createTextNode( `@font-face { font-family: ${ fontFamilyHeader.fontName }; src: url('${ fontFamilyHeader.fontUrl }') format('${ fontFamilyHeader.format }'); }` ) );
            document.head.appendChild( fontStyleEl );
        }
        if ( fontFamilyHeaderH2 && fontFamilyHeaderH2.fontUrl ) {
            let fontStyleEl = document.createElement( 'style' );

            fontStyleEl.appendChild( document.createTextNode( `@font-face { font-family: ${ fontFamilyHeaderH2.fontName }; src: url('${ fontFamilyHeaderH2.fontUrl }') format('${ fontFamilyHeaderH2.format }'); }` ) );
            document.head.appendChild( fontStyleEl );
        }
    }
};

/**
 *
 * @param appearance
 * @param customFonts
 * @returns {Promise<void>}
 */
const setPropxyFonts = async ( appearance, customFonts ) => {

    if ( appearance && appearance?.font_style ) {
        const { fontProps, fontFamilyHeader, fontFamilyHeaderH2 } = appearance.font_style;
        if ( fontProps && fontProps.fontUrl ) {
            const url = await new Promise( ( resp ) => {
                createFontBlob( customFonts.fontProps, resp );
            } );
            let fontStyleEl = document.createElement( 'style' );
            fontStyleEl.appendChild( document.createTextNode( `@font-face { font-family: ${ fontProps.fontName }; src: url('${ url }') format('${ fontProps.format }'); }` ) );
            document.head.appendChild( fontStyleEl );
        }

        if ( fontFamilyHeader && fontFamilyHeader.fontUrl ) {
            const url = await new Promise( ( resp ) => {
                createFontBlob( customFonts.fontFamilyHeader, resp );
            } );
            let fontStyleEl = document.createElement( 'style' );
            fontStyleEl.appendChild( document.createTextNode( `@font-face { font-family: ${ fontFamilyHeader.fontName }; src: url('${ url }') format('${ fontFamilyHeader.format }'); }` ) );
            document.head.appendChild( fontStyleEl );
        }

        if ( fontFamilyHeaderH2 && fontFamilyHeaderH2.fontUrl ) {
            const url = await new Promise( ( resp ) => {
                createFontBlob( customFonts.fontFamilyHeaderH2, resp );
            } );
            let fontStyleEl = document.createElement( 'style' );
            fontStyleEl.appendChild( document.createTextNode( `@font-face { font-family: ${ fontFamilyHeaderH2.fontName }; src: url('${ url }') format('${ fontFamilyHeaderH2.format }'); }` ) );
            document.head.appendChild( fontStyleEl );
        }
    }
};


/**
 *
 * @param color
 * @returns {{overlay: string, light: string, dark: string, type: string}|{overlay: string, light: string, dark: string, type: string}}
 */
const calculateContentColor = color => {
    let colorObj = rgbaStringToObject( color );
    let luminance = ( 0.299 * colorObj.r + 0.587 * colorObj.g + 0.114 * colorObj.b ) / 255;

    return luminance > 0.5 ?
        {
            light: 'rgba(0, 0, 0, 0.1)',
            dark: 'rgba(0, 0, 0, 1)',
            overlay: 'rgba(255, 255, 255, 0.9)',
            type: 'dark'
        } :
        {
            light: 'rgba(255, 255, 255, 0.3)',
            dark: 'rgba(255, 255, 255, 1)',
            overlay: 'rgba(0, 0, 0, 0.9)',
            type: 'light'
        };
};


/**
 *
 * @param fontPropsUrl
 * @param fontFamilyHeaderUrl
 * @param fontFamilyHeaderH2Url
 * @returns {FormData}
 */
const loadFonts = ( fontPropsUrl, fontFamilyHeaderUrl, fontFamilyHeaderH2Url ) => {
    const form = new FormData();

    if ( fontPropsUrl !== '' ) {
        form.append( 'font_props_val', fontPropsUrl );
    }

    if ( fontFamilyHeaderUrl !== '' ) {
        form.append( 'font_header_val', fontFamilyHeaderUrl );
    }

    if ( fontFamilyHeaderH2Url !== '' ) {
        form.append( 'fonts_header_h2_val', fontFamilyHeaderH2Url );
    }
    return form;
};

/**
 *
 * @returns {{}}
 */
const sendUserDetails = () => {
    const hrf = location.href;

    const query = hrf.split( '?' )[ 1 ];
    let params = new URLSearchParams(query);

    let items = [];

    if(params) {
        for (const [key, value] of params.entries()) {
            items[key] = value;
        }
    }

    return items;
};

/**
 *
 * @param link
 * @returns {string|boolean|*}
 */
const formatLink = ( link ) => {
    if ( !!link === false ) return false;
    if ( link.indexOf( 'http' ) === 0 ) {
        return link;
    } else {
        return `//${ link }`;
    }
};

/**
 *
 * @param key
 * @param quizType
 * @param typeId
 * @returns {string}
 */

const getShareURL = ( key, quizType, typeId ) => {
    let shareURL = '';
    const slash = isSlash();

    if ( window.location !== window.parent.location ) {

        const objLocation = new URL( window.location );

        let origin = '';
        if ( objLocation.searchParams.has( 'other-embed-url' ) ) {
            const href = objLocation.searchParams.get( 'other-embed-url' );
            origin = href.split( '?' ).length > 0 ? href.split( '?' )[ 0 ] : href;

            if ( origin === '' ) {
                const objUrl = new URL( document.referrer );
                const href = objUrl.href;
                origin = href.split( '?' ).length > 0 ? href.split( '?' )[ 0 ] : href;
            }

        } else {
            const objUrl = new URL( document.referrer );
            const href = objUrl.href;
            origin = href.split( '?' ).length > 0 ? href.split( '?' )[ 0 ] : href;
        }

        shareURL = key ? origin + '?key=' + key : origin;

    } else {
        let delKey = new URL( document.location.href );

        if ( quizType === 'person' ) {
            shareURL = key ? delKey.origin + delKey.pathname + `${ slash }` + `${ typeId }/` + '?key=' + key : delKey.origin + delKey.pathname + `${ slash }` + `${ typeId }/`;
        } else {
            shareURL = key ? delKey.origin + delKey.pathname + '?key=' + key : delKey.origin + delKey.pathname;
        }
    }

    shareURL = editUrl( shareURL, key );
    return shareURL;
};


/**
 *
 * @param font_family
 * @returns {{fontFamilyH2: *, fontFamilyH1: *, defaultFont: *}}
 */
const getFontFamily = ( font_family ) => {
    const defaultFont = font_family?.fontProps ? font_family?.fontProps?.fontName : font_family?.fontFamily;
    const fontFamilyH1 = font_family?.fontFamilyHeader ? font_family?.fontFamilyH1 : defaultFont;
    const fontFamilyH2 = font_family?.fontFamilyHeaderH2 ? font_family?.fontFamilyH2 : defaultFont;
    return { fontFamilyH1, fontFamilyH2, defaultFont };
};

/**
 *
 * @param backgroundColor
 * @returns {{fone: (string), color: string}}
 */
const getSwitchWithBackgroundColour = ( backgroundColor ) => {
    const lightOrDarkBackground = lightOrDark( backgroundColor );
    const fone = lightOrDarkBackground === 'light' ? 'rgba(0,0,0,1)' : 'rgba(150,150,150,0.5)';
    const color = lightOrDarkBackground === 'light' ? 'grey' : 'grey';
    return { fone, color };
};

/**
 *
 * @param backgroundColor
 * @returns {string}
 */
const getSwichColour = ( backgroundColor ) => {
    const lightOrDarkBackground = lightOrDark( backgroundColor );
    return lightOrDarkBackground === 'light' ? 'rgb(95,95,95)' : 'rgb(190,191,190)';
};

/**
 *
 * @param backgroundColor
 * @param lightClassName
 * @param lightClassNam
 * @param darckClassName
 * @returns {*}
 */
const getSwitchClassNameOrColourWithBackground = ( backgroundColor, lightClassName, darckClassName ) => {
    const lightOrDarkBackground = lightOrDark( backgroundColor );
    return lightOrDarkBackground === 'light' ? lightClassName : darckClassName;
};

/*

 */
const getScreenType = () => {
    return document.documentElement.clientWidth <= 500 ? 'Mobile' : 'Desktop';
};

/**
 *
 * @param question
 * @param screenType
 * @returns {*}
 */
const getBackgroundImage = ( question, screenType ) => {
    const screenPostfix = screenType === 'Desktop' ? '_desktop' : '';
    return get( question, `image${ screenPostfix }.url` )
        || get( question, 'image.url' );
};

/**
 *
 * @param fontStyle
 * @returns {{urlFontFamilyHeader: string, urlFontFamilyHeaderH2: string, urlFontProps: (*|string)}}
 */
const getProxyFont = ( fontStyle ) => {
    const { fontProps, fontFamilyHeader, fontFamilyHeaderH2 } = fontStyle;
    const urlFontProps = ( fontProps && typeof fontProps.fontUrl !== 'undefined' ) ? fontProps.fontUrl : '';
    const urlFontFamilyHeader = ( fontFamilyHeader && typeof fontFamilyHeader.fontUrl !== 'undefined' ) ? fontFamilyHeader.fontUrl : '';
    const urlFontFamilyHeaderH2 = ( fontFamilyHeaderH2 && typeof fontFamilyHeaderH2.fontUrl !== 'undefined' ) ? fontFamilyHeaderH2.fontUrl : '';
    return { urlFontProps, urlFontFamilyHeader, urlFontFamilyHeaderH2 };
};

/**
 *
 * @param elm
 * @param callBck
 */
const resizeListener = ( elm, callBck ) => {
    const resizeObserver = new ResizeObserver( entries => {
        for ( let entry of entries ) {
            if ( entry.contentBoxSize ) {
                if ( typeof callBck === 'function' ) {
                    callBck();
                }
            }
        }
    } );
    if ( typeof elm !== 'undefined' ) resizeObserver.observe( elm );
};

/**
 *
 * @param f
 * @param ms
 * @returns {function(): (undefined)}
 */
const debounceTwo = ( f, ms ) => {
    let isCooldown = false;

    return function () {
        if ( isCooldown ) return;
        f.apply( this, arguments );
        isCooldown = true;
        setTimeout( () => isCooldown = false, ms );
    };
};

/**
 *
 * @param answersObj
 * @returns {{value: *, key: *}[]}
 */
const objToArray = ( answersObj ) => {
    return Object.entries( answersObj ).map( ( elm ) => {
        const [ key, value ] = elm;
        return { key: key, value: value };
    } );
};

/**
 *
 * @param txt
 * @param fontname
 * @param fontsize
 * @returns {*}
 */
const getWidthOfText = ( txt, fontname, fontsize ) => {
    if ( getWidthOfText.c === undefined ) {
        getWidthOfText.c = document.createElement( 'canvas' );
        getWidthOfText.ctx = getWidthOfText.c.getContext( '2d' );
    }
    getWidthOfText.ctx.font = fontsize + 'px ' + fontname;
    return getWidthOfText.ctx.measureText( txt ).width;
};

/**
 *
 * @param block
 * @returns {{isVerticalScroll: boolean, isHorizontalScroll: boolean}}
 */
const getScroll = ( block ) => {
    if ( block ) {
        const isVerticalScroll = block.scrollHeight > block.clientHeight;
        const isHorizontalScroll = block.scrollWidth > block.clientWidth;
        return { isVerticalScroll, isHorizontalScroll };
    }
};

/**
 *
 * @param block
 */
const isScrollFinalRolled = ( block ) => {
    return Math.round( block.scrollHeight - block.scrollTop ) === block.clientHeight;
};

/**
 *
 * @param value
 * @returns {string|*}
 */
const valuePrint = ( value ) => {
    if ( value > 1000 && value <= 1000000 ) {
        return Math.round( ( ( value / 1000 ) * 100 ) / 100 ) + 'K';
    } else if ( value > 1000000 ) {
        return Math.round( ( ( value / 1000000 ) * 100 ) / 100 ) + 'M';
    } else return value;
};

/**
 *
 * @param file
 * @returns {Promise<unknown>}
 */
const fileToDataUrl = async ( file ) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL( file );
    return await new Promise( ( resolve ) => {
        fileReader.onload = ( f ) => {
            resolve( f.target.result );
        };
    } );
};

/**
 *
 * @returns {boolean}
 */
const isMobile = () => {
    return /iPhone|iPad|iPod|Android/i.test( navigator.userAgent );
};

/**
 *
 * @returns {boolean}
 */
const isMobilePhone = () => {
    return /iPhone|iPod|Android/i.test( navigator.userAgent );
};

/**
 *
 * @param elem
 * @returns {{top: number, left: number}}
 */
const getCoords = ( elem ) => {
    let box = elem.getBoundingClientRect();

    return {
        top: box.top + pageYOffset,
        left: box.left + pageXOffset
    };
};

/**
 *
 * @param func
 * @param delay
 * @returns {function(): void}
 */
const debounceThree = ( func, delay ) => {
    let debounceHandler;
    return function () {
        const context = this;
        const args = arguments;
        clearTimeout( debounceHandler );
        debounceHandler = setTimeout( () => func.apply( context, args ), delay );
    };
};

/**
 *
 * @param func
 * @param limit
 * @returns {function(): void}
 */
const throttle = ( func, limit ) => {
    let inThrottle;

    return function () {
        const args = arguments;
        const context = this;

        if ( !inThrottle ) {
            func.apply( context, args );
            inThrottle = true;
            setTimeout( () => ( inThrottle = false ), limit );
        }
    };
};

/**
 *
 * @type {{no: string, fi: string, ru: string, ch: string, gm: string, jp: string, kr: string, en: string, it: string, fr: string, se: string, nd: string, tk: string, bz: string, pl: string, hd: string, da: string, sp: string}}
 */
const langList = {
    en: 'English',
    se: 'Svenska',
    no: 'Norsk',
    da: 'Dansk',
    fi: 'Suomi',
    ru: 'Russian',
    sp: 'Spanish',
    ch: 'Chinese',
    bz: 'Portuguese',
    pl: 'Polish',
    tk: 'Turkish',
    nd: 'Dutch',
    fr: 'French',
    gm: 'German',
    hd: 'Hindi',
    it: 'Italian',
    jp: 'Japanese',
    kr: 'Korean'
};

/**
 *
 * @param string
 * @returns {*}
 */
const wrapUrlByTag = ( string ) => {
    try {
        const regExp = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        const findTheUrl = string.match( regExp );
        if ( findTheUrl === null ) {
            return string;
        } else {
            let tempString = string;

            if ( findTheUrl.length > 0 ) {
                for ( let c = 0 ; c < findTheUrl.length; c++ ) {
                    const url = findTheUrl[ c ];
                    const theUrlPattern = new RegExp(`${url}`,'g');
                    const theSameLink = string.match(theUrlPattern);
                    const htm = `<a target="_blank" href="${ findTheUrl[ c ] }">${ findTheUrl[ c ] }</a>`;
                    if(theSameLink.length > 1){
                        tempString =  tempString.replaceAll( url, htm );
                        break;
                    } else {
                        tempString = tempString.replace( url, htm );
                    }

                }
                return tempString;
            }
        }
    } catch ( e ) {
        // console.log( e );
    }
};

/**
 *
 * @param value
 * @param content
 * @returns {string}
 */
const timeSpentValue = ( value, content ) => {
    let val = 0;

    const formatedValue = String( value ).replace(',','');

    if ( typeof Number( formatedValue ) === 'number' ) {
        if ( Number( formatedValue ) > 60 ) {
            const printValue = Number( formatedValue ) / 60;
            return printValue.toFixed( 2 ) + `${ content.quiz.statistics.min }`;
        } else {
            if ( Number( formatedValue ) < 0 ) {
                val = 0;
            } else {
                val = Number( formatedValue ).toFixed( 1 );
            }
            return val + `${ content.quiz.statistics.sec }`;
        }
    }

    if ( typeof value === 'string' ) {
        return value;
    }
};
/**
 *
 * @param month
 * @returns {string}
 */
const enMonthToSe = ( month ) => {
    switch ( month ){
        case 'Jan': return 'jan';
        case 'Feb': return 'feb';
        case 'Mar': return 'mar';
        case 'Apr': return 'apr';
        case 'May': return 'maj';
        case 'Jun': return 'jun';
        case 'Jul': return 'jul';
        case 'Aug': return 'aug';
        case 'Sep': return 'sep';
        case 'Oct': return 'okt';
        case 'Nov': return 'nov';
        case 'Dec': return 'dec';
    }
};

const getSubUrl = () => {
    try {
        if ( typeof window.location === 'undefined' ) {
            throw new Error( 'window.location is undefined' );
        }
        const locationArr = new URL( window.location ).href.split( '/' );

        if ( locationArr.length === 0 ) {
            throw new Error( 'error data in locationArr.length ' );
        }

        return locationArr[ locationArr.length - 1 ];

    }catch ( e ){
        console.warn(e);
        return '';
    }
};

/**
 * Calculates the relative luminance of a given hex color.
 * @param {string} color - The hex color code (e.g., "#FFFFFF" or "#000000").
 * @returns {number} The luminance value of the color.
 */
const getLuminance = (color) => {
    const rgb = color.match(/\w\w/g).map((c) => parseInt(c, 16) / 255);
    const adjusted = rgb.map((c) =>
        c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)
    );
    return adjusted[0] * 0.2126 + adjusted[1] * 0.7152 + adjusted[2] * 0.0722;
};

/**
 * Calculates the contrast ratio between two colors.
 * @param {string} color1 - The first hex color code.
 * @param {string} color2 - The second hex color code.
 * @returns {number} The contrast ratio between the two colors.
 */
const getContrastRatio = (color1, color2) => {
    const lum1 = getLuminance(color1);
    const lum2 = getLuminance(color2);
    const [L1, L2] = lum1 > lum2 ? [lum1, lum2] : [lum2, lum1];

    return (L1 + 0.05) / (L2 + 0.05);
};

/**
 * Determines the WCAG compliance level based on the contrast ratio.
 * @param {number} ratio - The contrast ratio.
 * @returns {string} The compliance status message.
 */
const getComplianceStatus = (ratio) => {
    if (ratio >= 7) return "✅ AAA for normal text, ✅ AA for all";
    if (ratio >= 4.5) return "✅ AA for normal text, ✅ AA for large text";
    if (ratio >= 3) return "⚠️ AA for large text only, ❌ Fail for small text";
    return "❌ Fail (Not WCAG Compliant)";
};

/**
 * Checks the contrast ratio and WCAG compliance status between two colors.
 * @param {string} color1 - The first hex color code.
 * @param {string} color2 - The second hex color code.
 * @returns {object} An object containing the contrast ratio and compliance status.
 */
const checkContrast = (color1, color2) => {
    const contrastRatio = getContrastRatio(color1, color2).toFixed(2);
    const complianceStatus = getComplianceStatus(contrastRatio);
    return { contrastRatio, complianceStatus };
};

export {
    getSubUrl,
    enMonthToSe,
    timeSpentValue,
    wrapUrlByTag,
    langList,
    throttle,
    debounceThree,
    getCoords,
    isMobile,
    isMobilePhone,
    isScrollFinalRolled,
    fileToDataUrl,
    valuePrint,
    getScroll,
    getWidthOfText,
    objToArray,
    resizeListener,
    getProxyFont,
    getBackgroundImage,
    getScreenType,
    getSwitchClassNameOrColourWithBackground,
    getSwichColour,
    getSwitchWithBackgroundColour,
    getFontFamily,
    getShareURL,
    formatLink,
    sendUserDetails,
    loadFonts,
    setPropxyFonts,
    calculateContentColor,
    setFonts,
    editUrl,
    isSlash,
    onUnload,
    createFontBlob,
    generateId,
    escapeRegExp,
    debounce,
    debounceTwo,
    isRunningOnServerSide,
    isRunningOnClientSide,
    isFacebookApp,
    getLangIdByName,
    getLangCodeById,
    getLangNameById,
    getCapital,
    isIframe,
    isSupportedBrowser,
    useForceUpdate,
    drawBackgroundPix,
    createFoneImage,
    checkSafariBackdropSupport,
    checkContrast
};